import React from 'react';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { ParentCorpCreatePage } from 'src/components/enterprise/features/Corporate/ParentCorpCreatePage/ParentCorpCreatePage';
import { ParentCorpEditPage } from 'src/components/enterprise/features/Corporate/ParentCorpEditPage/ParentCorpEditPage';
import { ChildCorpEditPage } from 'src/components/enterprise/features/Corporate/ChildCorpEditPage/ChildCorpEditPage';

const ParentCreatePageLayout = withEnterpriseLayout(ParentCorpCreatePage);
const ParentEditPageLayout = withEnterpriseLayout(ParentCorpEditPage);
const ChildCorpEditPageLayout = withEnterpriseLayout(ChildCorpEditPage);

export const ParentCreateRoute = (): JSX.Element => (
  <ParentCreatePageLayout pageTitle="Create new parent account" />
);

export const ParentEditRoute = (): JSX.Element => (
  <ParentEditPageLayout pageTitle="Edit Parent Account" />
);

export const ChildCorpEditRoute = (): JSX.Element => (
  <ChildCorpEditPageLayout pageTitle="Edit Child Account" />
);
